/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */



  window.requestAnimFrame = (function(){
  return  window.requestAnimationFrame       ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame    ||
          function( callback ){
            window.setTimeout(callback, 1000 / 60);
            };
  })();

  var Utils = {};
  Utils.addEvent = (function () {
    var filter = function(el, type, fn) {
      for ( var i = 0, len = el.length; i < len; i++ ) {
        utils.addEvent(el[i], type, fn);
      }
    };
    if ( document.addEventListener ) {
      return function (el, type, fn) {
        if ( el && el.nodeName || el === window ) {
          el.addEventListener(type, fn, false);
        } else if (el && el.length) {
          filter(el, type, fn);
        }
      };
    }
    return function (el, type, fn) {
      if ( el && el.nodeName || el === window ) {
        el.attachEvent('on' + type, function () { return fn.call(el, window.event); });
      } else if ( el && el.length ) {
        filter(el, type, fn);
      }
    };
  })();

  var docCookies = {
    getItem: function (sKey) {
      if (!sKey) { return null; }
      return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    },
    setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
      if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
      var sExpires = "";
      if (vEnd) {
        switch (vEnd.constructor) {
          case Number:
            sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
            break;
          case String:
            sExpires = "; expires=" + vEnd;
            break;
          case Date:
            sExpires = "; expires=" + vEnd.toUTCString();
            break;
        }
      }
      document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
      return true;
    },
    removeItem: function (sKey, sPath, sDomain) {
      if (!this.hasItem(sKey)) { return false; }
      document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
      return true;
    },
    hasItem: function (sKey) {
      if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
      return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
    },
    keys: function () {
      var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
      for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
      return aKeys;
    }
  };



  function getElementIndex(node) {
    var index = 0;
    while ( (node = node.previousElementSibling) ) {
        index++;
    }
    return index;
  }

  function getCoords(elem) { // crossbrowser version
    var box = elem.getBoundingClientRect();

    var body = document.body;
    var docEl = document.documentElement;

    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;

    var top  = box.top +  scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;

    return { top: Math.round(top), left: Math.round(left) };
  }

  function scrollToY(o,n) { function a(){t+=1/60;var n=t/c,l=i(n);1>n?(requestAnimFrame(a),window.scrollTo(0,r+(o-r)*l)):window.scrollTo(0,o)}var r=window.scrollY,o=o||0,n=n||2e3,t=0,c=Math.max(.1,Math.min(Math.abs(r-o)/n,.8)),i=function(o){return-.5*(Math.cos(Math.PI*o)-1)};a()}

  function scrollToElement(event, el) {

    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
    //var el = event.target || event.originalTarget || event.srcElement;
    //var elId = '#' + (el.getAttribute("href") || el.href).slice(1);
    //var elId = '#' + el.getAttribute("href").substring(el.getAttribute("href").indexOf('#')+1);
    //el = document.querySelectorAll(elId);
    if (el) {
      //console.log(el);
      var elCoords = getCoords(el);
      var offsetTop = elCoords.top;
      offsetTop -= document.querySelector('.header').clientHeight;
      /*if ( window.innerWidth >= mobileMenuBreakpoint ) {
        offsetTop -= document.querySelector('.header').clientHeight;
      }*/
      scrollToY(offsetTop, 500);
      return false;
    }
  }


  /*function detectIE() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }*/
  var mobileMenuBreakpoint = 1024;

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Base = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        //var version = detectIE();


        // Fix horizontal scrolling with 100vw containers on IE and Edge
        function handleWindow() {
          var body = document.querySelector('body');
          if (window.innerWidth > body.clientWidth + 5) {
            body.classList.add('has-scrollbar');
            body.setAttribute('style', '--scroll-bar: ' + (window.innerWidth - body.clientWidth) + 'px');
          } else {
            body.classList.remove('has-scrollbar');
          }
        }

        // trigger scroll to make sure slow networks animate on opening
        setTimeout(function() {
          handleWindow();
        	window.dispatchEvent(new Event('scroll'));
        }, 300);

        const { body, documentElement } = document;
        let { scrollTopVal } = document.documentElement;
        function lockScroll() {
          scrollTopVal = documentElement.scrollTop;
          body.style.top = -scrollTopVal + 'px';
          body.style.overflowY = null;
          documentElement.style.overflowY = null;
          body.classList.add('lockscroll');
        }
        function unLockScroll() {
          body.classList.remove('lockscroll');
          documentElement.scrollTop = scrollTopVal;
          body.style.removeProperty('top');
        }


        var mainnav = document.querySelector('.header');
        var scrollTop = window.scrollY;
        var lastScrollTop = 0;
        var scrollTopDelta = 0;
        var scrollDelta = 0;

        function checkHeaderPos() {
          scrollTop = window.scrollY;
          scrollDelta = scrollTop - lastScrollTop;
          if ( scrollTop > 40 ) {
            mainnav.classList.remove('top');
            if ( scrollDelta > 0 ) {
              mainnav.classList.add('scrolled');

            } else {
              mainnav.classList.remove('scrolled');
            }
          } else {
            mainnav.classList.add('top');
            mainnav.classList.remove('scrolled');
          }
          lastScrollTop = scrollTop; // update last scroll top value
        }
        checkHeaderPos();




        // Make hero images bg for IE11
        /*if (version == 11 || version == 10) {
          var bgImgEls = document.querySelectorAll('.l-container__bg img');
          for (var ii = 0; ii < bgImgEls.length; ii++) {
            var imgContainer = bgImgEls[ii].parentElement;
            var imgUrl = bgImgEls[ii].getAttribute('data-lazy-src');
            if ( imgUrl == null) {
              imgUrl = bgImgEls[ii].getAttribute('src');
            }
            imgContainer.setAttribute('style', 'background-image: url(' + imgUrl + ');');
            imgContainer.classList.add('object-fit-ie');
          }
        }

        // Fix object fit for hero videos on IE and Edge
        function fixVideos() {
          // version returns false if anything else than IE or Edge
          if (version !== false) {
            var videoEls = document.querySelectorAll('.l-container__bg--video');
            for (var vi = 0; vi < videoEls.length; vi++) {
              var videoRatio = videoEls[vi].videoWidth / videoEls[vi].videoHeight;
              var wrapWidth = videoEls[vi].parentElement.clientWidth;
              var wrapHeight = videoEls[vi].parentElement.clientHeight;
              var wrapRatio = wrapWidth / wrapHeight;
              var newWidth = '100%';
              var newHeight = '100%';
              if (videoRatio < wrapRatio ) {
                newWidth = wrapWidth + 'px';
                newHeight = wrapWidth / videoRatio + 'px';
              } else {
                newWidth = wrapHeight * videoRatio + 'px';
                newHeight = wrapHeight + 'px';
              }
              videoEls[vi].style.width = newWidth;
              videoEls[vi].style.height = newHeight;
            }
          }
        }
        fixVideos();*/



        // Wrap iframes in responsive div. ONLY inside container blocks l-content div
        var players = [
          '.page-content iframe[src*="youtube.com"]',
          '.page-content iframe[src*="vimeo.com"]',
          '.page-content iframe[src*="google.com/maps"]',
          '.page-content iframe[data-src*="youtube.com"]',
          '.page-content iframe[data-src*="vimeo.com"]',
          '.page-content iframe[data-src*="google.com/maps"]'
        ];
        var fitVids = document.querySelectorAll(players.join(","));

        if (fitVids.length) {
          // Loop through videos
          for (var i = 0; i < fitVids.length; i++) {
            // Get Video Information
            var fitVid = fitVids[i];
            var width = fitVid.getAttribute("width");
            var height = fitVid.getAttribute("height");
            var aspectRatio = height / width;
            var parentDiv = fitVid.parentNode;

            // Wrap it in a DIV
            var div = document.createElement("div");
            div.className = "responsive-wrapper";
            div.style.paddingBottom = aspectRatio * 100 + "%";
            parentDiv.insertBefore(div, fitVid);
            fitVid.remove();
            div.appendChild(fitVid);

            // Clear height/width from fitVid
            fitVid.removeAttribute("height");
            fitVid.removeAttribute("width");
          }
        }

        //var submenuLinks = document.querySelectorAll('.menu-item-has-children > a');
        //var navigationLinks = document.querySelectorAll('.menu-item > a');
        var pageLinks = document.querySelectorAll('a');
	      var inPageLinks = document.querySelectorAll('a[href*="#"]');



        /*function animateValue(obj, start, end, duration, decimals) {
          if ( isNaN(start) || start == "" || isNaN(end) || end == "" || isNaN(duration) || duration == "" ) return;
          let startTimestamp = null;
          const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / parseInt(duration), 1);
            if ( decimals == 'true' ) {
              var newDecimalVal = Math.round( (progress * (parseFloat(end) - parseFloat(start)) + parseFloat(start)) * 10 ) / 10;
              newDecimalVal = newDecimalVal + '';
              obj.innerHTML = newDecimalVal.replace(".", ",");
            } else {
              obj.innerHTML = Math.floor(progress * (parseInt(end) - parseInt(start)) + parseInt(start));
            }
            if (progress < 1) {
              window.requestAnimationFrame(step);
            }
          };
          window.requestAnimationFrame(step);
        }*/



        // instantiate the scrollama
        var scroller = scrollama();
        // https://github.com/daneden/animate.css
        // https://github.com/russellgoldenberg/scrollama
        function initScrollama() {
          if ( document.querySelector('.js-animate, .l-content-column, .page-content') != null ) { // ,

            // setup the instance, pass callback functions
            scroller
              .setup({
                step: '.js-animate, .l-content-column, .l-row, .page-content > *', // ,
                offset: 0.85
              })
              .onStepEnter(function(response) {
                // { element, index, direction }
                response.element.classList.add('animated');

              })
              .onStepExit(function(response) {
                // { element, index, direction }
              });

            // setup resize event
            window.addEventListener("resize", scroller.resize);
          }
        }
        initScrollama();

        function closeNav() {
      		if ( document.querySelector('.header').classList.contains('nav-open') ) {
      			document.querySelector('.header').classList.remove('nav-open');
            //document.querySelector('body').classList.remove('nav-open');

            document.querySelector('.js-toggle-nav').setAttribute('aria-expanded', 'false');
      		}
      	}
        function toggleNav(e){
      		e.preventDefault();
      		if ( !document.querySelector('.header').classList.contains('nav-open') ) {
            //document.querySelector('body').classList.add('nav-open');
            lockScroll();
            document.querySelector('.js-toggle-nav').setAttribute('aria-expanded', 'true');
            setTimeout(function() {
              document.querySelector('.header').classList.add('nav-open');
            }, 500);
      		} else {
      			closeNav();
            unLockScroll();
      		}
      	}
        /*var navParents = document.querySelectorAll('.menu-item-has-children > a');
        for (i = 0; i < navParents.length; i++) {
          Utils.addEvent(navParents[i], 'click', function() {

          });
        }*/

      	// nav toggle
      	Utils.addEvent(document.querySelector('.js-toggle-nav'), 'click', toggleNav);
      	Utils.addEvent(document.querySelector('main'), 'click', closeNav);
      	Utils.addEvent(document.querySelector('.js-close-nav'), 'click', function(e) {
          e.preventDefault();
          closeNav();
        });

        // scroll to hash
      	var hash = window.location.hash;
      	if (hash) {
      		var target = document.getElementById(hash);
          target = target ? target : document.querySelector('#' + hash.slice(1));
      		if (target) {
            scrollToElement(event, target);
      		}
      	}

        // SUB MENUS
        // Add submenu indicators to menu items
        /*for (var i = 0; i < submenuLinks.length; i++) {
          var submenuIndicator = document.createElementNS("http://www.w3.org/2000/svg",'svg');
          submenuIndicator.innerHTML = '<use xlink:href="#i-menu-indicator" />';
          submenuLinks[i].append(submenuIndicator);
        }
        var submenuLinkToggles = document.querySelectorAll('.menu-item-has-children > a svg');

        // Open & close submenus (mobile devices only)
        for (var i = 0; i < submenuLinks.length; i++) {
          Utils.addEvent(submenuLinks[i], 'click', function(e) {
            if ( window.innerWidth < mobileMenuBreakpoint ) {
              if ( this.parentElement.classList.contains('active') ) {
                //this.parentElement.classList.remove('active');
              } else {
                e.preventDefault();
                this.parentElement.classList.add('active');
              }
            }
          });
      	}
        for (var i = 0; i < submenuLinkToggles.length; i++) {
          Utils.addEvent(submenuLinkToggles[i], 'click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if ( this.parentElement.parentElement.classList.contains('active') ) {
              this.parentElement.parentElement.classList.remove('active');
            } else {
              this.parentElement.parentElement.classList.add('active');
            }
          });
      	}*/


        // All content links
        // TODO käsittele figuren linkit paremmin. Ei ole p:n tai li:n sisällä mutta ei saa myöskään sotkea gallerian figure-elementteihin
        var contentLinks = document.querySelectorAll('.page-content a');
        for (var i = 0; i < contentLinks.length; i++) {
          var linkhref = contentLinks[i].getAttribute('href');

          // Add class to all links pointing to image
          if (
            !contentLinks[i].parentElement.classList.contains('gallery-item') && !contentLinks[i].parentElement.classList.contains('gallery-icon')
            && linkhref != null
            && (linkhref.indexOf("webp") > 0 || linkhref.indexOf("jpg") > 0 || linkhref.indexOf("jpeg") > 0 || linkhref.indexOf("png") > 0)
          ) {
            contentLinks[i].classList.add('js-image-link');
          }

          // add classes to youtube links
          if ( linkhref != null) {
            var matches_yt = linkhref.match(/watch\?v=([a-zA-Z0-9\-_]+)/);
            if ( matches_yt ) {
              contentLinks[i].classList.add('js-open-yt');
              contentLinks[i].classList.add('video-link');
              var playArrow = document.createElementNS("http://www.w3.org/2000/svg",'svg');
              playArrow.innerHTML = '<use xlink:href="#i-play" />';
              contentLinks[i].append(playArrow);
            }
          }

          // add classes to vimeo links
          if ( linkhref != null) {
            var matches_vim = linkhref.match(/vimeo.com\/([a-zA-Z0-9\-_]+)/);
            if ( matches_vim ) {
              contentLinks[i].classList.add('js-open-vimeo');
              contentLinks[i].classList.add('video-link');
              var playArrow = document.createElementNS("http://www.w3.org/2000/svg",'svg');
              playArrow.innerHTML = '<use xlink:href="#i-play" />';
              contentLinks[i].append(playArrow);
            }
          }
        }


        // in page links
      	for (var i = 0; i < inPageLinks.length; i++) {

          // Skip all empty links AND target exists on page
          //  && !inPageLinks[i].classList.contains('show-more')
          if ( inPageLinks[i].getAttribute('href') !== '#' ) {
            var currentLinkHref = '';
            var currentPageUrl = '';
            currentLinkHref = inPageLinks[i].getAttribute('href');
            currentPageUrl = window.location.href;

            currentLinkHref = currentLinkHref.replace(/^https?\:\/\//i, "");
            currentLinkHref = currentLinkHref.replace(/^\/\//i, "");
            currentPageUrl = currentPageUrl.replace(/^https?\:\/\//i, "");

            // Scroll to content if current href is only hash or url matches to current page url AND has hash AND current hash target exists on page
            if (
              (currentLinkHref.split('#')[0] === '' ||
              currentLinkHref.split('#')[0] === currentPageUrl.split('#')[0] ||
              currentLinkHref.split('#')[0] + '/' === currentPageUrl.split('#')[0] ) &&
              document.querySelectorAll('#' + currentLinkHref.split('#')[1]).length != 0
            ) {
              Utils.addEvent(inPageLinks[i], 'click', function() {

                // Use link hash as selector. If for some reason not possible, use linkhref
                var linkHref = '';
                var linkHash = '';
                linkHref = this.getAttribute('href');
                linkHash = linkHref.split('#')[1];
                var target = document.querySelector('#' + linkHash);
                target = target ? target : document.querySelector('#' + linkHref);
                // Don't scroll if show more is already open

              	if ( target ) {
                  scrollToElement(event, target);
                }
              });

            }
          }

      	}

        baguetteBox.run('.js-image-link', {
          noScrollbars: true,
          animation: 'fadeIn',
          overlayBackgroundColor: false,
          captions: function(element) {
            if ( element.parentElement.getElementsByTagName('figcaption')[0] ) {
              return element.parentElement.getElementsByTagName('figcaption')[0].innerHTML;
            }
          }
        });
        baguetteBox.run('.gallery', {
          noScrollbars: true,
          animation: 'slideIn', //'fadeIn' / 'slideIn'
          overlayBackgroundColor: false,
          leftArrow: '',
          buttons: true,
          captions: function(element) {
            if ( element.parentElement.getElementsByTagName('figcaption')[0] ) {
              return element.parentElement.getElementsByTagName('figcaption')[0].innerHTML;
            }
          }
        });
        // Change baguettebox svg elements
        if ( document.querySelector('#previous-button') ) {
          document.querySelector('#previous-button').innerHTML = '<svg><use xlink:href="#i-chevron" /></svg>';
          document.querySelector('#next-button').innerHTML = '<svg><use xlink:href="#i-chevron" /></svg>';
          document.querySelector('#close-button').innerHTML = '<svg><use xlink:href="#i-x" /></svg>';
        }

        // open social sharing window
        var socialWindowOpen = document.querySelectorAll('.js-social-window');
        for (var i = 0; i < socialWindowOpen.length; i++) {
          Utils.addEvent(socialWindowOpen[i], 'click', function (event) {
      			event.preventDefault();
      			window.open(this.getAttribute("href"), "popupWindow", "width=600,height=600,scrollbars=yes");
      		});
      	}


        // Close modal
        var modalCloseLinks = document.querySelectorAll('.js-close-modal');
        var modals = document.querySelectorAll('.js-modal');
        for (var i = 0; i < modalCloseLinks.length; i++) {
          Utils.addEvent(modalCloseLinks[i], 'click', function(e) {
            closeModals();
          	e.preventDefault();
          });
        }

        // Yt-modals close from bg click
        Utils.addEvent(document.querySelector('.js-video-modal'), 'click', function(e) {
          closeModals();

          e.preventDefault();
        });

        function closeModals() {
          unLockScroll();
          for (var j = 0; j < modals.length; j++) {
            modals[j].classList.remove('is-open');
            if ( modals[j].classList.contains('js-video-modal') ) {
              modals[j].querySelector('.js-video-modal .modal__content').innerHTML = "";
              document.querySelector('.js-open-search').setAttribute('aria-expanded', 'false');
            }
          }
        }

        // Youtube modals
        var youtubePlayLinks = document.querySelectorAll('.js-open-yt');
      	for (var i = 0; i < youtubePlayLinks.length; i++) {
      		Utils.addEvent(youtubePlayLinks[i], 'click', function(e) {
            if ( !document.querySelector('.js-video-modal').classList.contains('is-open') ) {
              var url = new URL(this.getAttribute('href'));
              var vid = url.searchParams.get("v");
      				lockScroll();
      				document.querySelector('.js-video-modal').classList.add('is-open');
      				document.querySelector('.js-video-modal').classList.add('modal--player');
              document.querySelector('.js-video-modal .modal__content').innerHTML = '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + vid + '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
            }
      			e.preventDefault();
      		});
      	}
        // Vimeo modals
        var vimeoPlayLinks = document.querySelectorAll('.js-open-vimeo');
        for (var i = 0; i < vimeoPlayLinks.length; i++) {
          Utils.addEvent(vimeoPlayLinks[i], 'click', function(e) {
            if ( !document.querySelector('.js-video-modal').classList.contains('is-open') ) {
              var url = new URL(this.getAttribute('href'));
              var vid = url.pathname;
              lockScroll();
              document.querySelector('.js-video-modal').classList.add('is-open');
              document.querySelector('.js-video-modal').classList.add('modal--player');
              document.querySelector('.js-video-modal .modal__content').innerHTML = '<iframe src="https://player.vimeo.com/video' + vid + '?title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
            }
            e.preventDefault();
          });
        }

        // Search modal
        Utils.addEvent(document.querySelector('.js-open-search'), 'click', function(e) {
          if ( !document.querySelector('.js-search-modal').classList.contains('is-open') ) {
            this.setAttribute('aria-expanded', 'true');
            lockScroll();
            document.querySelector('.js-search-modal').classList.add('is-open');
            setTimeout(function() {
              document.querySelector('.js-search-modal .search-field').focus();
            }, 500);
          }
          e.preventDefault();
        });



        /*var parallaxContainers = document.querySelectorAll('.parallax');

        function runParallax() {
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop || body.scrollTop;
          for (var i = 0; i < parallaxContainers.length; i++) {
            var parallaxEl = parallaxContainers[i];
            var parallaxPos = getCoords(parallaxEl);
            var parallaxElHeight = parallaxEl.clientHeight;
            var parallaxElTop = parallaxPos.top;
            var parallaxElBottom = parallaxPos.top + parallaxElHeight;

            var scrollBottom = scrollTop + window.innerHeight;
            var parallaxOffset = 0; // in px how much to move element up
            var parallaxSpeed = 0.1; // factor of speed for parallaxOffset change. Smaller number is slower

            // Parallax-scrollattavan elementin yläreuna on parentin 0 = top: 0;
            // Parallax-scrollattavan elementin korkeus on oltava riittävä, jotta skrollatessa alareunasta ei näy tyhjää
            // Oikea korkeus prosentteina on skrollausnopeudella kerrottu ruudun korkeuden ja elementin korkeuden summan suhde elementin korkeuteen
            var offsetHeight = (parallaxElHeight + (parallaxElHeight + window.innerHeight) * parallaxSpeed) / parallaxElHeight;

            parallaxEl.style.setProperty('--p-speed', parallaxSpeed);
            parallaxEl.style.setProperty('--p-height', offsetHeight);

            // Run parallax when element is visible
            if ( scrollBottom > parallaxElTop && scrollTop < parallaxElBottom ) {
              //console.log(window.innerHeight + ' vs. ' + parallaxElHeight );
              parallaxOffset = scrollBottom - parallaxElTop;
              parallaxEl.style.setProperty('--p-offset', parallaxOffset + 'px');

            }

          }

        }
        runParallax();*/



        var debounce = function(func, wait, immediate) {
      	    var timeout;
      	    return function() {
      	        var context = this, args = arguments;
      	        clearTimeout(timeout);
      	        timeout = setTimeout(function() {
      	            timeout = null;
      	            if (!immediate) func.apply(context, args);
      	        }, wait);
      	        if (immediate && !timeout) func.apply(context, args);
      	    };
      	};

        // debounced resize event
      	var resizeDebounce = debounce(function() {
          //fixVideos();
      	}, 100);
      	window.addEventListener('resize', resizeDebounce);


      	// scroll function
      	var scrollDebounce = debounce(function() {
          checkHeaderPos();
          //runParallax();
      	}, 10);
      	window.addEventListener('scroll', scrollDebounce);

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Base;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      var pageClasses = document.body.className.replace(/-/g, '_').split(/\s+/);
      for (var iP = 0; iP < pageClasses.length; iP++) {
        UTIL.fire(pageClasses[iP]);
        UTIL.fire(pageClasses[iP], 'finalize');
      }

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  document.addEventListener('DOMContentLoaded', UTIL.loadEvents);
